import { colors } from "../../theme/colors"

export const ContentContainer = {
  width: "100%",
  display: "flex",
  flex: 1,
  flexDirection: "column",
}
export const ButtonStyle = {
  width: "100%",
}

export const BanksContainer = {
  flex: 1,
  overflow: "scroll",
  msOverflowStyle: "none",
  scrollbarWidth: "0px",
  "&::-webkit-scrollbar ": {
    display: "none",
  },
  paddingBottom: "24px",
}

export const OperationsContainer = {
  flex: 1,
  overflow: "scroll",
  msOverflowStyle: "none",
  scrollbarWidth: "0px",
  "&::-webkit-scrollbar ": {
    display: "none",
  },
  paddingBottom: "24px",
}

export const BottomButtonContainer = {
  bottom: 0,
  paddingTop: "6px",
  backgroundColor: "white",
  boxShadow: "0px -20px 40px 12px rgba(255, 255, 255, 1)",
  maxWidth: "440px",
  left: "50%",
  width: "100%",
  boxSizing: "border-box",
}

export const TitleContainer = {
  marginTop: "24px",
  marginBottom: "8px",
}

export const LoadingContainer = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "10px",
}

export const LoadingSx = {
  color: colors.black,
}
